export const TABS_REDUCER_NAMES = {
  GEOSPOOF: 'geospoof',
  IMAGERY: 'imagery',
  LAYERS: 'layers',
  OPERATIONAL: 'operational',
};
